import { computed, getCurrentInstance } from 'vue';
import { useCollectStore } from '@/stores/collect';

const ONLINE_TOKEN = 'app.device.list.connection_status.online';
const OFFLINE_TOKEN = 'app.device.list.connection_status.offline';

export function connectionStatusToken(available: boolean): string {
  return available ? ONLINE_TOKEN : OFFLINE_TOKEN;
}

export function useConnectionStatus() {
  const proxy = getCurrentInstance()?.proxy as { $online?: boolean } | undefined;

  const collectStore = useCollectStore();

  const online = computed(() => Boolean(proxy?.$online));
  const serverAvailable = computed(() => Boolean(collectStore.serverIsAvailable));

  const statusToken = computed(() => connectionStatusToken(online.value));
  const serverStatusToken = computed(() => connectionStatusToken(serverAvailable.value));

  return { online, serverAvailable, statusToken, serverStatusToken };
}
